
import MoneyAdd from "../../../assets/duotone/MoneyAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MoneyAddIcon({ className, dataTestid = "MoneyAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MoneyAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
